/**
 * Small numeric helpers shared by the award calculators, the matchup report
 * builder, and the fetcher. Pure and browser-safe (root export).
 */

/** Rounds to 2 decimal places, the precision every published score uses. */
export function round2(n: number): number {
  return Math.round(n * 100) / 100;
}

export function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max);
}

/** Mean of `values`, or 0 for an empty list. */
export function average(values: readonly number[]): number {
  return values.length === 0 ? 0 : values.reduce((sum, v) => sum + v, 0) / values.length;
}

/** Win percentage with a tie counted as half a win; 0 before any games. */
export function winPct({ wins, losses, ties }: { wins: number; losses: number; ties: number }): number {
  const total = wins + losses + ties;
  return total === 0 ? 0 : (wins + ties / 2) / total;
}
